module.exports = __webpack_public_path__ + "static/media/New-transfer-inactive.8850ae29.svg";